import { Component, OnInit, ViewChild } from '@angular/core';
import { Repository } from '../../../services/repository';
import { BsModalComponent } from 'ng2-bs3-modal';
import { Lists_chuongtrinhkhuyenmai } from '../../../routes/menu';

const swal = require('sweetalert');

@Component({
  selector: 'app-chuongtrinhkhuyenmai',
  templateUrl: './chuongtrinhkhuyenmai.component.html',
  styleUrls: ['./chuongtrinhkhuyenmai.component.scss'],
  providers: [Repository]
})
export class ChuongTrinhKhuyenMaiComponent implements OnInit {

  @ViewChild('mdThemKhuyenMai') mdThemKhuyenMai: BsModalComponent;

  // Data properties
  public datas: any[] = [];
  public currentUser: any;
  public loading = false;
  public modalTitle = 'Thêm chương trình khuyến mại';

  // Permission properties
  public quyen_them: boolean = false;
  public quyen_sua: boolean = false;
  public quyen_xoa: boolean = false;
  public danhSachLop: any[] = [];
  // Pagination properties
  public totalItems: number = 0;
  public currentPage: number = 1;
  public pageSize: number = 20;
  public totalPages: number = 0;
  public pages: any[] = [];

  // Search/Filter properties
  public TimKiems: any = {
    NoiDung: null,
    TuNgay: null,
    DenNgay: null,
    SoTienGiam: null,
    HoatDong: null,
    NguoiSua: null,
    startPage: null,
    LoaiApDung: null, // Thêm field mới
    endPage: null
  };

  // New voucher form properties
  public newVoucher: any = {
    NoiDung: '',
    TuNgay: new Date(new Date().getFullYear(), 0, 1), // First day of current year
    DenNgay: new Date(new Date().getFullYear(), 11, 31), // Last day of current year
    SoTienGiam: null,
    LoaiApDung: '', // Thêm field mới
    HoatDong: true
  };
  // Thêm vào phần khai báo thuộc tính
  public loaiApDungOptions = [ 
    { id: '1', name: 'Tính theo buổi thu sau' },
    { id: '6', name: 'Tính theo buổi thu trước' },
    { id: '2', name: 'Tính theo tháng' },
    { id: '3', name: 'Tính theo gói' }
  ];

  // Thêm phương thức để hiển thị text của loại áp dụng
  public getLoaiApDungText(id: string): string {
    const item = this.loaiApDungOptions.find(x => x.id === id);
    return item ? item.name : '';
  }
  // Currency options for number inputs
  public ngxCurrencyOptions = {
    align: "right",
    allowNegative: true,
    allowZero: true,
    decimal: ",",
    precision: 0,
    prefix: "",
    suffix: "",
    thousands: ".",
    nullable: true
  };

  // Date filter properties
  public ngayTimKiemTu: Date = null;
  public ngayTimKiemDen: Date = null;

  // Selected row for actions
  public selectedId: any = null;
  public selectedRow: any = null;
  public username: string;
  public donviId: string;
  constructor(private repo: Repository) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.username = this.currentUser.user_name;
    this.donviId = this.currentUser.id_don_vi;
    if (this.currentUser != null) {
      // Check permissions
      var giatri = this.currentUser.ds_quyen.filter(name => name.Id === Lists_chuongtrinhkhuyenmai.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        this.quyen_them = giatri[0].Them || false;
        this.quyen_sua = giatri[0].Sua || false;
        this.quyen_xoa = giatri[0].Xoa || false;
      }
    }

    this.loadDanhSachLop();
  }

  ngOnInit(): void {
    
  }
  loadDanhSachLop(): void {

    this.repo.postRequest('api/hoso/combolophoc', { UserName: this.username, DonViId: this.donviId })
      .subscribe(response => {
        this.danhSachLop = response;
      });

  }
  // Translation helper
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }

  nhanSuId: any;
  // Load voucher data
  loadDataInit(id_nhan_su: any): void {

    this.nhanSuId = id_nhan_su;
    this.loading = true;

    const startPage = (this.currentPage - 1) * this.pageSize + 1;
    const endPage = this.currentPage * this.pageSize;

    const searchParams = {
      ...this.TimKiems,
      NhanSuId: id_nhan_su,
      startPage: startPage,
      endPage: endPage,
      TuNgayS: this.ngayTimKiemTu ? this.formatDate(this.ngayTimKiemTu) : null,
      DenNgayS: this.ngayTimKiemDen ? this.formatDate(this.ngayTimKiemDen) : null
    };

    this.repo.postRequest('api/hocvien/danhsachkhuyenmai', searchParams)
      .subscribe(response => {
        this.loading = false;
        this.totalPages = 0;
        this.totalItems = 0;

        if (response.length > 0) {
          const item = response[0];
          this.totalItems = item["totalRows"];
          this.totalPages = Math.ceil(this.totalItems / this.pageSize);
          this.generatePagination();
        }

        this.datas = response;
      }, error => {
        this.loading = false;
        console.error('Error loading data:', error);
      });
  }

  // Generate pagination array
  generatePagination(): void {
    let start, end;

    if (this.totalPages <= 4) {
      start = 1;
      end = this.totalPages;
    } else {
      if (this.currentPage <= 2) {
        start = 1;
        end = 4;
      } else if (this.currentPage + 1 >= this.totalPages) {
        start = this.totalPages - 3;
        end = this.totalPages;
      } else {
        start = this.currentPage - 1;
        end = this.currentPage + 1;
      }
    }

    this.pages = [];
    for (let i = start; i <= end; i++) {
      this.pages.push({ Id: i });
    }
  }

  // Format date for API
  formatDate(date: Date): string {
    return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
  }

  // Search/Filter events
  onKeydownEvent(event: KeyboardEvent): void {
    if (event.keyCode === 13) {
      this.search();
    }
  }

  search(): void {
    this.currentPage = 1;
    this.loadDataInit(this.nhanSuId);
  }

  // Pagination methods
  setPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }
    this.currentPage = page;
    this.loadDataInit(this.nhanSuId);
  }

  onBlur(): void {
    this.loadDataInit(this.nhanSuId);
  }

  // Row selection
  selectRow(row: any): void {
    this.selectedId = row.Id;
    this.selectedRow = row;
  }

  // Modal operations
  openAddModal(): void {
    this.modalTitle = 'Thêm chương trình khuyến mại';
    this.newVoucher = {
      nhanSuId: this.nhanSuId,
      NoiDung: '',
      LoaiApDung: 1,
      LopId:null,
      TuNgay: new Date(new Date().getFullYear(), 0, 1),
      DenNgay: new Date(new Date().getFullYear(), 11, 31),
      SoTienGiam: null,
      HoatDong: true,
      IsSum:false
    };
    this.mdThemKhuyenMai.open();
  }

  openEditModal(): void {
    if (!this.selectedRow) {
      swal('Lỗi!', 'Vui lòng chọn chương trình khuyến mại để sửa!', 'error');
      return;
    }

    this.modalTitle = 'Sửa chương trình khuyến mại';
    this.newVoucher = {
      Id: this.selectedRow.Id,
      LopId: this.selectedRow.LopId,
      LoaiApDung: this.selectedRow.LoaiApDung,
      NoiDung: this.selectedRow.NoiDung,
      TuNgay: new Date(this.selectedRow.TuNgay),
      DenNgay: new Date(this.selectedRow.DenNgay),
      SoTienGiam: this.selectedRow.SoTienGiam,
      HoatDong: this.selectedRow.HoatDong,
      IsSum: this.selectedRow.IsSum
    };
    this.mdThemKhuyenMai.open();
  }

  // Save voucher
  saveVoucher(): void {
    // Validation
    if (!this.newVoucher.NoiDung || this.newVoucher.NoiDung.trim() === '') {
      swal('Lỗi!', 'Vui lòng nhập nội dung chương trình khuyến mại!', 'error');
      return;
    }

    if (!this.newVoucher.TuNgay) {
      swal('Lỗi!', 'Vui lòng chọn ngày bắt đầu!', 'error');
      return;
    }

    if (!this.newVoucher.DenNgay) {
      swal('Lỗi!', 'Vui lòng chọn ngày kết thúc!', 'error');
      return;
    }

    if (this.newVoucher.TuNgay >= this.newVoucher.DenNgay) {
      swal('Lỗi!', 'Ngày bắt đầu phải nhỏ hơn ngày kết thúc!', 'error');
      return;
    }

    if (!this.newVoucher.SoTienGiam || this.newVoucher.SoTienGiam <= 0) {
      swal('Lỗi!', 'Vui lòng nhập số tiền giảm hợp lệ!', 'error');
      return;
    }
     
    const voucherData = {
      Id: this.newVoucher.Id || null,
      NoiDung: this.newVoucher.NoiDung,
      TuNgay: this.newVoucher.TuNgay,
      DenNgay: this.newVoucher.DenNgay,
      SoTienGiam: this.newVoucher.SoTienGiam,
      HoatDong: this.newVoucher.HoatDong,
      IsSum: this.newVoucher.IsSum,
      Loai: this.newVoucher.LoaiApDung,
      LopId: this.newVoucher.LopId,
      NhanSuId: this.nhanSuId,
      CreatedBy: this.currentUser?.user_name,
      ModifiedBy: this.currentUser?.user_name
    };

    this.repo.postRequest('api/hocvien/themkhuyenmai', voucherData)
      .subscribe(response => {
        if (response === 'OK') {
          swal('Thành công!', 'Lưu chương trình khuyến mại thành công!', 'success');
          this.mdThemKhuyenMai.close();
          this.loadDataInit(this.nhanSuId);
        } else {
          swal('Cảnh báo!', response, 'warning');
        }
      }, error => {
        swal('Lỗi!', 'Có lỗi xảy ra khi lưu dữ liệu!', 'error');
        console.error('Error saving voucher:', error);
      });
  }

  // Delete voucher
  deleteVoucher(): void {
    if (!this.selectedRow) {
      swal('Lỗi!', 'Vui lòng chọn chương trình khuyến mại để xóa!', 'error');
      return;
    }

    swal({
      title: 'Bạn muốn xóa chương trình khuyến mại này?',
      text: 'Hành động này không thể hoàn tác!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    }).then(willDelete => {
      if (willDelete) {
        this.repo.postRequest('api/hocvien/xoakhuyenmai', {
          Id: this.selectedRow.Id,
          UserName: this.currentUser.user_name
        }).subscribe(
          data => {
            if (data === "OK") {
              swal('Đã xóa!', 'Chương trình khuyến mại đã được xóa!', 'success');
              this.selectedId = null;
              this.selectedRow = null;
              this.loadDataInit(this.nhanSuId);
            } else {
              swal('Cảnh báo!', data, 'warning');
            }
          },
          error => {
            swal('Lỗi!', 'Có lỗi xảy ra khi xóa dữ liệu!', 'error');
          }
        );
      }
    });
  }

  // Close modal
  closeModal(): void {
    this.mdThemKhuyenMai.close();
  }

  // Status filter
  filterByStatus(status: boolean): void {
    this.TimKiems.HoatDong = status;
    this.search();
  }

  // Clear all filters
  clearFilters(): void {
    this.TimKiems = {
      NoiDung: null,
      TuNgay: null,
      DenNgay: null,
      SoTienGiam: null,
      HoatDong: null,
      IsSum:null,
      NguoiSua: null,
      startPage: null,
      endPage: null
    };
    this.ngayTimKiemTu = null;
    this.ngayTimKiemDen = null;
    this.search();
  }

  // Refresh data
  refreshData(): void {
    this.clearFilters();
  }
}
